import { Link } from 'react-router-dom';
import { boards } from '@/mocks/community';

const toneMap = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-700',
  'bg-background-200 text-foreground-700',
];

export default function Boards() {
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center">
          <span className="text-xs font-semibold tracking-widest text-primary-600">DISCUSS AREA</span>
          <h2 className="mt-1 font-heading text-2xl md:text-3xl">按兴趣找到你的圈子</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
            从热血打斗到治愈日常，从悬疑推理到新番资讯，总有一个板块适合你畅所欲言。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {boards.map((b, idx) => (
            <Link
              key={b.id}
              to="/community"
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 hover:border-primary-300 hover:-translate-y-0.5 transition-all"
            >
              <div className="flex items-start justify-between">
                <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${toneMap[idx % toneMap.length]}`}>
                  <i className={`${b.icon} text-xl`}></i>
                </span>
                {b.hot && (
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-700">
                    <i className="ri-fire-fill"></i>热门
                  </span>
                )}
              </div>
              <h3 className="mt-4 text-base md:text-lg font-bold text-foreground-950">{b.name}</h3>
              <p className="mt-1.5 flex-1 text-xs md:text-sm leading-relaxed text-foreground-600">{b.desc}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span>{b.posts.toLocaleString()} 帖</span>
                <span className="text-primary-700 group-hover:translate-x-0.5 transition-transform">
                  今日 +{b.today} <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}